<ngx-loading [show]="loading"></ngx-loading>
<div class="p-3 d-flex flex-column align-items-center light-grey-background" *ngIf="!isOpenPaymentModal">
  <h6 class="navy-font text-center">REFUND</h6>
  <form [formGroup]="returnForm" class="w-100 payment-form">
    <mat-radio-group name="returnType" formControlName="returnType">
      <!-- Product Section -->
      <div class="card mb-2">
        <div class="card-body">
          <mat-radio-button data-test-id="returnProduct" [value]="PaymentType.RefundProduct">
            Product
          </mat-radio-button>
          <div
            formArrayName="formReturnProducts"
            *ngFor="let productControl of formReturnProductsControls; let i = index; let length = count"
          >
            <div [formGroupName]="i" class="w-100 d-flex align-items-center justify-content-between">
              <div class="w-100 navy-font d-flex flex-column">
                <div
                  class="d-flex align-items-center w-100 flex-grow-1"
                  [ngClass]="{
                    'form-field-disabled': returnType !== PaymentType.RefundProduct
                  }"
                >
                  <div class="w-100">
                    <mat-form-field [floatLabel]="'never'">
                      <mat-select
                        formControlName="product"
                        data-test-id="returnProductName"
                        (selectionChange)="onSelectProductsPurchased(i)"
                      >
                        <mat-option
                          *ngFor="let item of productsPurchased"
                          [value]="item"
                          [ngClass]="{ 'force-hide': isSelectedProduct(item) }"
                        >
                          <div class="d-flex flex-column w-100" style="line-height: 1.3em">
                            <div class="d-flex">
                              <div class="text-left mr-1" style="width: calc(100% / 3)">
                                Invoice #{{ item.invoiceId }}
                              </div>
                              <div class="text-left text-truncate flex-grow-1" style="width: calc(100% / 3)">
                                {{ item.quantity }}x {{ item.name }}
                              </div>
                              <div class="text-right">{{ item.pricePaid | currency }}</div>
                            </div>
                            <div class="d-flex">
                              <span
                                *ngIf="item.purchaseDate; else servicesListSpacer"
                                class="font-weight-light text-truncate mr-auto"
                                style="color: grey; font-size: 0.8em"
                              >
                                {{ item.purchaseDate | date : 'yyyy-MM-dd' }}</span
                              >
                              <ng-template #servicesListSpacer>&nbsp;</ng-template>
                            </div>
                          </div>
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <ng-container *ngIf="productControl.get('productQuantity') as productQuantityControl">
                    <div *ngIf="productControl?.value?.product?.quantity > 1" class="navy-font flex-shrink-1 ml-2">
                      <div class="d-flex align-items-center">
                        Qty:
                        <div class="ml-2">
                          <mat-form-field [floatLabel]="'never'" style="min-width: 4em">
                            <input
                              matInput
                              data-test-id="returnProductQuantity"
                              type="number"
                              min="1"
                              [max]="productControl?.value?.product?.quantity"
                              formControlName="productQuantity"
                            />
                            <mat-error
                              *ngIf="
                                productQuantityControl?.hasError('required') &&
                                (productQuantityControl?.dirty || productQuantityControl?.touched)
                              "
                            >
                              Qty. is required
                            </mat-error>
                            <mat-error
                              *ngIf="
                                productQuantityControl?.hasError('quantityInvalid') &&
                                (productQuantityControl?.dirty || productQuantityControl?.touched)
                              "
                            >
                              Qty. must be at least 1
                            </mat-error>
                            <mat-error
                              *ngIf="
                                productQuantityControl?.hasError('quantityExceeds') &&
                                (productQuantityControl?.dirty || productQuantityControl?.touched)
                              "
                            >
                              Max Qty. is {{ productQuantityControl?.getError('quantityExceeds') }}
                            </mat-error>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                  <button
                    *ngIf="length > 1"
                    type="button"
                    class="btn btn-sm em-btn em-btn-green ml-2"
                    data-test-id="returnRemoveProduct"
                    (click)="removeProduct(i)"
                  >
                    <i class="far fa-minus-circle"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div
            [ngClass]="{
              'form-field-disabled': returnType !== PaymentType.RefundProduct
            }"
          >
            <button type="button" class="btn btn-sm em-btn em-btn-green" (click)="addProduct()">
              <i class="far fa-plus-circle"></i>
            </button>
          </div>
        </div>
      </div>
      <!-- Clinic Supplies Section -->
      <div class="card mb-2">
        <div class="card-body">
          <mat-radio-button
            data-test-id="returnClinicSupply"
            [disabled]="!clinicSupplies?.length"
            [value]="PaymentType.RefundClinicSupply"
          >
            Clinic Supply
          </mat-radio-button>
          <div
            formArrayName="formReturnClinicSupplies"
            *ngFor="let clinicSupplyControl of formReturnClinicSuppliesControls; let i = index; let length = count"
          >
            <div [formGroupName]="i" class="w-100 d-flex align-items-center justify-content-between">
              <div class="w-100 navy-font d-flex flex-column">
                <div
                  class="d-flex align-items-center w-100 flex-grow-1"
                  [ngClass]="{
                    'form-field-disabled': returnType !== PaymentType.RefundClinicSupply
                  }"
                >
                  <div class="w-100">
                    <mat-form-field [floatLabel]="'never'">
                      <mat-select
                        formControlName="clinicSupply"
                        data-test-id="returnClinicSupplyName"
                        (selectionChange)="onSelectClinicSupply(i)"
                      >
                        <mat-select-trigger>
                          Invoice# {{ clinicSupplyControl?.value.clinicSupply?.invoiceId }}
                          {{ clinicSupplyControl?.value.clinicSupply?.supplyName }} -
                          {{ clinicSupplyControl?.value.clinicSupply?.purchasedQuantity | number : '1.0-2' }}
                          {{ clinicSupplyControl?.value.clinicSupply?.unitName }} -
                          {{ clinicSupplyControl?.value.clinicSupply?.pricePaid | currency }}
                        </mat-select-trigger>
                        <mat-option
                          *ngFor="let item of clinicSupplies"
                          [value]="item"
                          [disabled]="
                            item.observationListRemainingQuantity <= 0 || item.invoiceLineItemRemainingQuantity <= 0
                          "
                          [ngClass]="{ 'force-hide': isSelectedClinicSupply(item) }"
                        >
                          <div class="d-flex flex-column w-100" style="line-height: 1.3em">
                            <div class="d-flex">
                              <div class="text-left" style="width: calc(100% / 3)">Invoice #{{ item.invoiceId }}</div>
                              <div class="text-left text-truncate flex-grow-1">
                                {{ item.supplyName }} - {{ item.purchasedQuantity | number : '1.0-2' }}
                                {{ item.unitName }}
                              </div>
                              <div class="text-right">{{ item.pricePaid | currency }}</div>
                            </div>
                            <div class="d-flex">
                              <span
                                *ngIf="item.purchaseDate; else spacer"
                                class="font-weight-light text-truncate mr-auto"
                                style="color: grey; font-size: 0.8em"
                              >
                                {{ item.purchaseDate | date : 'yyyy-MM-dd' }}</span
                              >
                              <span
                                *ngIf="item.invoiceLineItemRemainingQuantity; else spacer"
                                class="font-weight-light text-truncate text-right mr-1"
                                style="color: grey; font-size: 0.8em"
                              >
                                Line Item Remaining: {{ item.invoiceLineItemRemainingQuantity | number : '1.0-2' }}
                                {{ item.unitName }}</span
                              >
                              <span
                                *ngIf="item.observationListRemainingQuantity; else spacer"
                                class="font-weight-light text-truncate text-right"
                                style="color: grey; font-size: 0.8em; width: 106px"
                              >
                                Total Remaining: {{ item.observationListRemainingQuantity | number : '1.0-2' }}
                                {{ item.unitName }}</span
                              >
                            </div>
                          </div>
                        </mat-option>
                      </mat-select>
                      <mat-hint>
                        <div class="d-flex">
                          <span
                            *ngIf="
                              clinicSupplyControl?.value.clinicSupply?.invoiceLineItemRemainingQuantity &&
                              clinicSupplyControl?.value.clinicSupply?.observationListRemainingQuantity
                            "
                            class="mr-1"
                          >
                            Line Item Remaining:
                            {{
                              clinicSupplyControl?.value.clinicSupply?.invoiceLineItemRemainingQuantity
                                | number : '1.0-2'
                            }}
                            {{ clinicSupplyControl?.value.clinicSupply?.unitName }}&nbsp;-&nbsp;Total Remaining:
                            {{
                              clinicSupplyControl?.value.clinicSupply?.observationListRemainingQuantity
                                | number : '1.0-2'
                            }}
                            {{ clinicSupplyControl?.value.clinicSupply?.unitName }}</span
                          >
                        </div>
                      </mat-hint>
                    </mat-form-field>
                  </div>
                  <ng-container *ngIf="clinicSupplyControl.get('clinicSupplyQuantity') as clinicSupplyQuantityControl">
                    <div *ngIf="clinicSupplyControl?.value?.clinicSupply" class="navy-font flex-shrink-1 ml-2">
                      <div class="d-flex align-items-center">
                        Qty:
                        <div class="ml-2">
                          <mat-form-field [floatLabel]="'never'" style="min-width: 4em">
                            <input
                              matInput
                              data-test-id="returnClinicSupplyQuantity"
                              type="number"
                              min="1"
                              [max]="getMinClinicSupplyRemaining(clinicSupplyControl?.value?.clinicSupply)"
                              formControlName="clinicSupplyQuantity"
                            />
                            <mat-error
                              *ngIf="
                                clinicSupplyQuantityControl?.hasError('required') &&
                                (clinicSupplyQuantityControl?.dirty || clinicSupplyQuantityControl?.touched)
                              "
                            >
                              Qty. is required
                            </mat-error>
                            <mat-error
                              *ngIf="
                                clinicSupplyQuantityControl?.hasError('quantityInvalid') &&
                                (clinicSupplyQuantityControl?.dirty || clinicSupplyQuantityControl?.touched)
                              "
                            >
                              Qty. must be greater than 0
                            </mat-error>
                            <mat-error
                              *ngIf="
                                clinicSupplyQuantityControl?.hasError('quantityExceeds') &&
                                (clinicSupplyQuantityControl?.dirty || clinicSupplyQuantityControl?.touched)
                              "
                            >
                              Max Qty. is {{ clinicSupplyQuantityControl?.getError('quantityExceeds') }}
                            </mat-error>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                  <button
                    *ngIf="length > 1"
                    type="button"
                    class="btn btn-sm em-btn em-btn-green ml-2"
                    data-test-id="returnRemoveClinicSupply"
                    (click)="removeClinicSupply(i)"
                  >
                    <i class="far fa-minus-circle"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div
            [ngClass]="{
              'form-field-disabled': returnType !== PaymentType.RefundClinicSupply
            }"
          >
            <button
              type="button"
              class="btn btn-sm em-btn em-btn-green"
              (click)="addClinicSupply()"
              [disabled]="!clinicSupplies?.length"
            >
              <i class="far fa-plus-circle"></i>
            </button>
          </div>
        </div>
      </div>
      <!-- Service Section -->
      <div class="card mb-2">
        <div class="card-body">
          <mat-radio-button data-test-id="returnService" [value]="PaymentType.RefundService">
            Service
          </mat-radio-button>
          <div
            formArrayName="formReturnServices"
            *ngFor="let serviceControl of formReturnServicesControls; let i = index"
          >
            <div [formGroupName]="i" class="w-100 d-flex align-items-center justify-content-between">
              <div class="w-100 navy-font d-flex flex-column font-weight-bold">
                <div
                  class="d-flex align-items-center w-100"
                  [ngClass]="{
                    'form-field-disabled': returnType !== PaymentType.RefundService
                  }"
                >
                  <div class="w-100">
                    <mat-form-field [floatLabel]="'never'">
                      <mat-select
                        formControlName="service"
                        [attr.data-test-id]="'return-service-select-open-' + i"
                        (selectionChange)="onSelectServicePurchased(i)"
                      >
                        <mat-select-trigger
                          >Invoice #{{ serviceControl?.value.service?.invoiceId }}
                          {{ serviceControl?.value.service?.name }}
                          {{ serviceControl?.value.service?.pricePaid | currency }}</mat-select-trigger
                        >
                        <mat-option
                          *ngFor="let item of servicesPurchased"
                          [value]="item"
                          [attr.data-test-id]="
                            'return-service-select-' +
                            item.invoiceId +
                            '-' +
                            item.name +
                            (!item.serviceTypeDescription ? '' : '-' + item.serviceTypeDescription)
                          "
                          [ngClass]="{ 'force-hide': isSelectedService(item) || item.pricePaid === 0 }"
                        >
                          <div class="d-flex flex-column w-100" style="line-height: 1.3em">
                            <div class="d-flex">
                              <div class="text-left" style="width: calc(100% / 3)">Invoice #{{ item.invoiceId }}</div>
                              <div class="d-inline-flex" style="width: calc((100% / 3) * 2)">
                                <span class="text-left text-truncate">{{ item.name }} </span>
                                <div class="flex-grow-1 text-right">{{ item.pricePaid | currency }}</div>
                              </div>
                            </div>
                            <div class="d-flex">
                              <span
                                *ngIf="item.purchaseDate; else spacer"
                                class="font-weight-light text-truncate mr-auto"
                                style="color: grey; font-size: 0.8em"
                              >
                                {{ item.purchaseDate | date : 'yyyy-MM-dd' }}</span
                              >
                              <span
                                *ngIf="item.serviceTypeDescription; else spacer"
                                class="font-weight-light text-truncate ml-auto"
                                style="color: grey; font-size: 0.8em"
                              >
                                {{ item.serviceTypeDescription }}</span
                              >
                            </div>
                          </div>
                        </mat-option>
                      </mat-select>
                      <mat-hint>{{ serviceControl?.value?.service?.serviceTypeDescription }}</mat-hint>
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>
            <div [formGroup]="plannedTreatmentMultiplesForm" *ngIf="isPlannedTreatmentMultiple" class="pt-2">
              <mat-checkbox
                *ngFor="let plannedTreatment of plannedTreatmentMultiple?.plannedTreatments"
                class="pl-4"
                style="display: block"
                [disabled]="plannedTreatment.treatmentState !== TreatmentState.Unplanned"
                (click)="plannedTreatmentMultipleClick(plannedTreatment)"
                >{{ plannedTreatmentMultiple?.service }}: {{ plannedTreatmentMultiple?.price | currency }} -
                <span
                  *ngIf="
                    plannedTreatment.treatmentState === TreatmentState.Scheduled ||
                    plannedTreatment.treatmentState === TreatmentState.Completed
                  "
                  >{{ plannedTreatment.plannedDate | date : 'yyyy-MM-dd' }}</span
                >
                <span *ngIf="plannedTreatment.treatmentState === TreatmentState.Unplanned"> Available</span>
                <span *ngIf="plannedTreatment.treatmentState === TreatmentState.Returned"> Refunded </span>
              </mat-checkbox>
            </div>
          </div>
        </div>
      </div>
      <!-- Admin Fee Section -->
      <div class="card mb-2">
        <div class="card-body">
          <mat-radio-button data-test-id="returnAdminFee" [value]="PaymentType.RefundAdminFee">
            Admin Fee
          </mat-radio-button>
          <div formArrayName="formReturnFees" *ngFor="let returnFeeControl of formReturnFeesControls; let i = index">
            <div [formGroupName]="i" class="w-100 d-flex align-items-center justify-content-between">
              <div class="w-100 navy-font d-flex flex-column font-weight-bold">
                <div
                  class="d-flex align-items-center w-100"
                  [ngClass]="{
                    'form-field-disabled': returnType !== PaymentType.RefundAdminFee
                  }"
                >
                  <div class="w-100">
                    <mat-form-field [floatLabel]="'never'">
                      <mat-select formControlName="fee" [attr.data-test-id]="'return-fee-select-open-' + i">
                        <mat-select-trigger
                          >Invoice #{{ returnFeeControl.value.fee?.invoiceId }}
                          {{ returnFeeControl.value.fee?.pricePaid | currency }}
                        </mat-select-trigger>
                        <mat-option
                          *ngFor="let item of adminFeesPurchased"
                          [value]="item"
                          [attr.data-test-id]="
                            'return-fee-select-' +
                            item.invoiceId +
                            '-' +
                            (!item.serviceTypeDescription ? '' : '-' + item.serviceTypeDescription)
                          "
                          [ngClass]="{ 'force-hide': isSelectedFee(item) || item.pricePaid === 0 }"
                        >
                          <div class="d-flex flex-column w-100" style="line-height: 1.3em">
                            <div class="d-flex">
                              <div class="text-left" style="width: calc(100% / 3)">Invoice #{{ item.invoiceId }}</div>
                              <div class="d-inline-flex" style="width: calc((100% / 3) * 2)">
                                <div class="flex-grow-1 text-right">{{ item.pricePaid | currency }}</div>
                              </div>
                            </div>
                            <div class="d-flex">
                              <span
                                *ngIf="item.purchaseDate; else spacer"
                                class="font-weight-light text-truncate mr-auto"
                                style="color: grey; font-size: 0.8em"
                              >
                                {{ item.purchaseDate | date : 'yyyy-MM-dd' }}</span
                              >
                              <span
                                *ngIf="item.serviceTypeDescription; else spacer"
                                class="font-weight-light text-truncate ml-auto"
                                style="color: grey; font-size: 0.8em"
                              >
                                {{ item.serviceTypeDescription }}</span
                              >
                            </div>
                          </div>
                        </mat-option>
                      </mat-select>
                      <mat-hint>{{ returnFeeControl.value?.fee?.serviceTypeDescription }}</mat-hint>
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Cancellations Section -->
      <div class="card mb-2">
        <div class="card-body">
          <mat-radio-button data-test-id="returnPaidCancellation" [value]="PaymentType.RefundPaidCancellation">
            Cancellation Fee
          </mat-radio-button>
          <div
            formArrayName="formPaidCancellations"
            *ngFor="let paidCancellationControl of formPaidCancellationsControls; let i = index"
          >
            <div [formGroupName]="i" class="w-100 d-flex align-items-center justify-content-between">
              <div class="w-100 navy-font d-flex flex-column font-weight-bold">
                <div
                  class="d-flex align-items-center w-100"
                  [ngClass]="{
                    'form-field-disabled': returnType !== PaymentType.RefundPaidCancellation
                  }"
                >
                  <div class="w-100">
                    <mat-form-field [floatLabel]="'never'">
                      <mat-select
                        formControlName="paidCancellation"
                        [attr.data-test-id]="'paid-cancellation-select-open-' + i"
                      >
                        <mat-select-trigger
                          >Invoice #{{ paidCancellationControl.value?.paidCancellation?.invoiceId }}
                          {{
                            paidCancellationControl.value?.paidCancellation?.pricePaid | currency
                          }}</mat-select-trigger
                        >
                        <mat-option
                          *ngFor="let item of paidCancellations"
                          [value]="item"
                          [attr.data-test-id]="
                            'paid-cancellation-select-' +
                            item.invoiceId +
                            '-' +
                            (!item.description ? '' : '-' + item.description)
                          "
                          [ngClass]="{ 'force-hide': isSelectedPaidCancellation(item) || item.pricePaid === 0 }"
                        >
                          <div class="d-flex flex-column w-100" style="line-height: 1.3em">
                            <div class="d-flex">
                              <div class="text-left" style="width: calc(100% / 3)">Invoice #{{ item.invoiceId }}</div>
                              <div class="d-inline-flex" style="width: calc((100% / 3) * 2)">
                                <div class="flex-grow-1 text-right">{{ item.pricePaid | currency }}</div>
                              </div>
                            </div>
                            <div class="d-flex">
                              <span
                                *ngIf="item.purchaseDate; else spacer"
                                class="font-weight-light text-truncate mr-auto"
                                style="color: grey; font-size: 0.8em"
                              >
                                {{ item.purchaseDate | date : 'yyyy-MM-dd' }}</span
                              >
                              <span
                                *ngIf="item.description; else spacer"
                                class="font-weight-light text-truncate ml-auto"
                                style="color: grey; font-size: 0.8em"
                              >
                                {{ item.description }}</span
                              >
                            </div>
                          </div>
                        </mat-option>
                      </mat-select>
                      <mat-hint>{{ paidCancellationControl.value?.paidCancellation?.description }}</mat-hint>
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Credit Section -->
      <div class="card mb-2">
        <div class="card-body">
          <mat-radio-button
            [disabled]="!creditsPurchased || creditsPurchased <= 0"
            data-test-id="returnCredit"
            [value]="PaymentType.RefundCredit"
          >
            Credit
          </mat-radio-button>
          <div formArrayName="formReturnCredits" *ngFor="let creditControl of formReturnCreditsControls; let i = index">
            <div [formGroupName]="i" class="w-100">
              <div class="w-100 navy-font d-flex flex-column font-weight-bold">
                <ng-container *ngIf="creditControl.get('creditQuantity') as creditQuantityControl">
                  <div
                    class="d-flex align-items-center w-100 flex-grow-1"
                    [ngClass]="{
                      'mb-3':
                        creditQuantityControl?.invalid &&
                        (creditQuantityControl?.dirty || creditQuantityControl?.touched),
                      'form-field-disabled': returnType !== PaymentType.RefundCredit
                    }"
                  >
                    <div class="navy-font d-flex flex-column w-100">
                      <div class="d-flex align-items-center">
                        Amount ($):
                        <div class="flex-grow-1 ml-1">
                          <mat-form-field [floatLabel]="'never'">
                            <input
                              matInput
                              RestrictDecimalPlacesNumber
                              [nDecimalPlaces]="2"
                              numericType="decimal"
                              formControlName="creditQuantity"
                              data-test-id="returnCreditQuantity"
                            />
                            <mat-error
                              *ngIf="
                                creditQuantityControl?.hasError('required') &&
                                (creditQuantityControl?.dirty || creditQuantityControl?.touched)
                              "
                            >
                              Amount is required
                            </mat-error>
                            <mat-error
                              *ngIf="
                                creditQuantityControl?.hasError('quantityInvalid') &&
                                (creditQuantityControl?.dirty || creditQuantityControl?.touched)
                              "
                            >
                              Enter an amount greater than 0
                            </mat-error>
                            <mat-error
                              *ngIf="
                                creditQuantityControl?.hasError('quantityExceeds') &&
                                (creditQuantityControl?.dirty || creditQuantityControl?.touched)
                              "
                            >
                              Credit available to refund: ${{ creditsPurchased | number : '1.2-2' }}
                            </mat-error>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-radio-group>
    <div class="d-flex">
      <button
        type="button"
        class="schedNewCommButton em-btn em-btn-green py-2 px-3 mb-0 mx-auto"
        (click)="onReturnFormSubmit()"
        data-test-id="returnNextPage"
        [disabled]="nextDisabled()"
        [ngClass]="{
          'form-field-disabled': nextDisabled()
        }"
      >
        Next
      </button>
    </div>
  </form>
</div>

<ng-template #spacer>&nbsp;</ng-template>

<div class="next-step" [ngClass]="{ active: isOpenPaymentModal }">
  <app-invoice-payment
    [patientId]="patientId"
    [invoice]="selectedInvoice"
    [paidCancellation]="paidCancellation"
    (backToReturnPanel)="backToReturnPanel()"
    (paymentComplete)="onInvoicePay()"
  >
  </app-invoice-payment>
</div>
